import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import format from 'date-fns/format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { Button } from '@smartplatform/ui';
import ConvocationEdit from './ConvocationEdit';
import store from '../../store';
import { positions } from './ConvocationEdit';

const FORMAT = 'dd.MM.yyyy';

@observer
export default class Convocations extends React.Component {
	@observable convocations = [];
	@observable convocationPopup = null;

	constructor(props) {
		super(props);
		this.sendProps = { ...props, onClose: this.closePopup, onChange: this.init };
		this.init();
	}

	init = async () => {
		this.convocations = await store.model.DeputyConvocation.find({
			where: {
				deputyId: this.props.deputy.id,
			},
			include: [
				{ relation: 'convocation' },
				{ relation: 'fraction', scope: { fields: { id: true, shortName: true } } },
				{ relation: 'division', scope: { fields: { id: true, name: true } } },
				{ relation: 'divisionGroup', scope: { fields: { id: true, name: true } } },
			],
			order: 'convocationId desc',
		});
		// this.convocationPopup = <ConvocationEdit {...this.sendProps} deputyConvocation={this.convocations[0]} />;
	};

	showAddPopup = () => {
		this.convocationPopup = <ConvocationEdit {...this.sendProps} />;
	};

	showEditPopup = (e, deputyConvocation) => {
		e.preventDefault();
		this.convocationPopup = <ConvocationEdit {...this.sendProps} deputyConvocation={deputyConvocation} />;
	};

	closePopup = () => (this.convocationPopup = null);

	render() {
		return (
			<div className="convocations">
				<table className="list">
					<thead>
						<tr>
							<th>Созыв</th>
							<th>Фракция</th>
							<th>Избирательный округ / региональная группа</th>
							<th>Начало полномочий</th>
							<th>Конец полномочий</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{this.convocations.map(depConv => {
							const division = (
								<>
									{depConv.divisionGroup
										? depConv.divisionGroup.name
										: depConv.division
										? `${depConv.division.name} №${depConv.division.number}`
										: depConv.divisionText || ''}
								</>
							);
							return (
								<tr key={depConv.id}>
									{depConv.convocation && <td className="name">{depConv.convocation.name}</td>}
									<td className="name">
										{depConv.fraction ? `${depConv.fraction.shortName}, ${positions[depConv.positionNum || 0]}` : '-'}
									</td>
									<td className="name">{division}</td>
									<td className="date">{depConv.startDate ? format(new Date(depConv.startDate), FORMAT) : '-'}</td>
									<td className="date">{depConv.endDate ? format(new Date(depConv.endDate), 'dd.MM.yyyy HH:mm') : '-'}</td>
									{/*<td className="end">{deputyConvocation.end ? <FontAwesomeIcon icon={faCheck}/> : ''}</td>*/}
									<td>
										<a href="#" onClick={e => this.showEditPopup(e, depConv)}>
											Редактировать
										</a>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
				<p>
					<Button onClick={this.showAddPopup}>Добавить</Button>
				</p>
				{this.convocationPopup}
			</div>
		);
	}
}
